// VIS-267: the ground's control (splat) maps per season, kept on the graphics chip for the season shown only.
// Each season paints its two control maps (RGBA8, 1 px a metre, with mips: ~14 MB at Aurora) with its first ground
// paint (main.js paintGround). They used to stay for every season visited. Now, once a switch has drawn, the other
// seasons' maps are freed on the graphics chip (release); their texture objects stay, so that season's ground
// materials keep their programs, and a switch back paints the maps again (wants) and fills the same textures (put).
//   const maps = createSeasonMaps({ make: () => new THREE.Texture(), fill(t, image) {...}, free(image) {...} })
//   maps.wants(s)            -> does season s's next paint need its control maps painted?
//   maps.put(s, images)      -> the season's textures (made, or filled again after a release); extra images are freed
//   maps.get(s)              -> the season's textures (null before its first paint)
//   maps.release(keep)       -> frees every other season's maps on the graphics chip; -> the seasons freed
export function createSeasonMaps({ make, fill, free = () => {} }) {
  const bySeason = new Map(); // season -> [Texture, ...]
  const freed = new Set(); // seasons whose textures are off the graphics chip (to be filled before they are drawn)
  return {
    wants: (s) => !bySeason.has(s) || freed.has(s),
    get: (s) => bySeason.get(s) || null,
    put(s, images) {
      const have = bySeason.get(s);
      if (!have) { const ts = images.map((im) => fill(make(), im)); bySeason.set(s, ts); return ts; }
      if (!freed.has(s)) { images.forEach(free); return have; } // a later paint of a kept season: its maps are already there
      freed.delete(s);
      // the same texture objects (the materials keep their programs), each let go first: whatever made one again while
      // its season was away (from its closed picture: 1x1) goes, and three makes it anew at the picture's size
      have.forEach((t, i) => { t.dispose(); fill(t, images[i]); });
      return have;
    },
    release(keep) {
      const out = [];
      for (const [s, ts] of bySeason) if (s !== keep && !freed.has(s)) { ts.forEach((t) => t.dispose()); freed.add(s); out.push(s); }
      return out;
    },
    isFreed: (s) => freed.has(s),
  };
}
